import { Backdrop, Box, Fade, IconButton, Modal, makeStyles } from "@material-ui/core";
import * as React from "react";
import { IFileDropModalProps } from "../../../@types/components/fileDropModal.types";
import CloseIcon from "@material-ui/icons/Close";

// eslint-disable-next-line prettier/prettier
const useStyles = makeStyles(theme => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: "15px",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(1, 4, 3)
	},
	actionIcon: {
		color: "#424242",
		marginTop: 5,
		marginRight: 5,
		fontSize: "1.1rem"
	}
}));

const style = {
	position: "absolute" as const,
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "none",
	borderRadius: 4,
	boxShadow: 24,
	p: 4
};

const DocumentsModal = ({ open, handleClose, child }: IFileDropModalProps) => {
	const classes = useStyles();
	return (
		<div>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500
				}}
			>
				<Fade in={open}>
					<Box className={classes.paper}>
						<div style={{ display: "flex", justifyContent: "flex-end" }}>
							<IconButton
								style={{
									color: "grey",
									padding: "10px",
									cursor: "pointer"
								}}
								edge="end"
								color="inherit"
								onClick={handleClose}
								aria-label="close"
							>
								<CloseIcon fontSize="small" />
							</IconButton>
						</div>
						{child}
					</Box>
				</Fade>
			</Modal>
			{/* </Backdrop> */}
		</div>
	);
};

export default DocumentsModal;
